// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__1D1DU","Success":"button_Success__3YVI7","Danger":"button_Danger__3XWXC"};